import { ControlledSelectCheckmark } from 'Components/ControlledSelectCheckmark';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext, useEffect, useState } from 'react';
import { RequestTypeIds } from 'reducer/PaymentsAndDeductions/AdvancedSearchReducer';

export const PaymentDeductionType = () => {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.PaymentsDeductions
  ).search;

  const isDesktop = useIsDesktop();
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const checkmarkOptions = [
    dictionary.groupStatus.refund,
    dictionary.groupStatus.payment,
    dictionary.groupStatus.deduction,
  ];

  useEffect(() => {
    const { deduction, payment, refund } = advancedSearch.requestType;
    const selectedTypes: string[] = [];
    if (refund) selectedTypes.push(dictionary.groupStatus.refund);
    if (deduction) selectedTypes.push(dictionary.groupStatus.deduction);
    if (payment) selectedTypes.push(dictionary.groupStatus.payment);
    setSelectedValues(selectedTypes);
  }, [advancedSearch.requestType, dictionary.groupStatus]);

  return (
    <ControlledSelectCheckmark
      disablePortal={isDesktop ? false : true}
      label={dictionary.accordingToType}
      options={checkmarkOptions}
      selected={selectedValues}
      onChange={(e) => {
        const value = e.target.value;
        const requestTypes: number[] = [];
        if (value?.includes(dictionary.groupStatus.refund))
          requestTypes.push(RequestTypeIds.refund);
        if (value?.includes(dictionary.groupStatus.deduction))
          requestTypes.push(RequestTypeIds.deduction);
        if (value?.includes(dictionary.groupStatus.payment))
          requestTypes.push(RequestTypeIds.payment);
        dispatchAdvancedSearch({
          type: 'SET_REQUEST_TYPES',
          payload: { requestTypes },
        });
      }}
      size={'small'}
    />
  );
};
